import { between } from "polished";
import { vars } from "./variables.css";
import { style } from "@vanilla-extract/css";
import { jsVars } from "./variables";
import { FieldValues } from "react-hook-form";

const cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

export default function getValueAndUnit(value: string | number): any {
  if (typeof value !== "string") return [value, ""];
  const matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

export const breakpoints = {
  desktop: "1920px",
  tabletLandscape: "962px",
  tabletLandscapeHeight: "601px",
  tablet: "768px",
  mobile: "380px",
};

export const fluid = (min: string, from = breakpoints.tabletLandscape) => {
  const [minValue, minUnit] = getValueAndUnit(min);
  const [fromValue] = getValueAndUnit(from);

  return `calc((${minValue} / ${fromValue}) * 100cqw)`;
};

export const fluidHeight = (
  min: string,
  from = breakpoints.tabletLandscapeHeight
) => {
  const [minValue, minUnit] = getValueAndUnit(min);
  const [fromValue] = getValueAndUnit(from);

  return `calc((${minValue} / ${fromValue}) * 100vh)`;
};

export const truncate = (string: string, length = 159, suffix = "...") => {
  if (string.length > length) {
    return string.substring(0, length) + suffix;
  }
  return string;
};

type TypographyStyle = {
  fontFamily: string;
  fontWeight: string;
  lineHeight: string;
  fontSize: string;
  letterSpacing: string;
  textDecoration: string;
};

export const fluidTypography = (typography: TypographyStyle) => {
  return style([
    {
      fontFamily: typography.fontFamily,
      fontWeight: typography.fontWeight,
      lineHeight: fluid(typography.lineHeight),
      fontSize: fluid(typography.fontSize),
      letterSpacing: fluid(typography.letterSpacing),
      textDecoration: typography.textDecoration,
    },
  ]);
};

// https://github.com/typeandpixel/roadset-frontend/blob/master/assets/styles/_mixins.scss#L22
export const objectFitViewport = ({
  direction = "up",
  width,
  height,
}: {
  direction?: "up" | "down";
  width: number;
  height: number;
}) => {
  const map = {
    down: "max",
    up: "min",
  };
  const mediaFeature = `${map[direction]}-aspect-ratio`;

  const styles = {
    top: "0",
    left: `calc(50vw - ${width}/${height}/2 * 100vh)`,
    width: `calc(${width}/${height} * 100vh)`,
    height: "100vh",
    "@media": {
      [`(${mediaFeature}: ${width} / ${height})`]: {
        top: `calc(50vh - ${height}/${width}/2 * 100vw)`,
        left: "0",
        width: "100vw",
        height: `calc(${height}/${width} * 100vw)`,
      },
    },
  };

  return styles;
};

export const calcFinalScore = (submittedItems: FieldValues, items: any) => {
  let totalCorrect = 0;

  Object.entries(submittedItems).forEach((item) => {
    const submittedAnswers = item[1];
    const correctAnswers = items.find(
      (answer: { id: string }) => answer.id === `${item[0]}`
    )?.answers;

    let correctItems = 0;

    submittedAnswers.length === correctAnswers?.length &&
    Array.isArray(submittedAnswers)
      ? (submittedAnswers.forEach((submittedItem: any) => {
          correctAnswers?.find(
            (correctAnswer: any) => correctAnswer === submittedItem
          ) && correctItems++;
        }),
        correctItems === correctAnswers?.length && totalCorrect++)
      : correctAnswers?.find(
          (correctAnswer: any) => correctAnswer === submittedAnswers
        ) && totalCorrect++;
  });

  return totalCorrect;
};
